import React from 'react';
import { useSelector } from 'react-redux';
import { List } from 'immutable';

// Utils
import * as ReviewsUtils from 'Shared/utils/Reviews.utils';

// Selectors
import * as ReviewsSelectors from 'Shared/selectors/Reviews.selectors';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';
import * as ReviewFormHelpers from 'Shared/model_helpers/ReviewForm.helper';
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Components
import ReviewForm from '../../ThreeSixtyReviewPartials/ReviewForm/ReviewForm';

type Props = {
  review;
};
const SharePageReviewForm = ({ review }: Props) => {
  const reviewSlug = ReviewsHelpers.getSlug(review);
  const reviewForm = useSelector(state =>
    ReviewsSelectors.getReviewFormsByReviewSlugAndType(state, { reviewSlug, formType: 'compilation' }).first()
  );

  const answers = ReviewFormHelpers.getAnswers(reviewForm);
  const formData = ReviewFormHelpers.getFormData(reviewForm);
  const formSlug = ReviewFormHelpers.getSlug(reviewForm);
  const peerReviewTemplate = ReviewsUtils.getFormTemplateForForm({ review, templateFormType: 'peer_review' });
  const peerReviewQuestions = ReviewFormTemplatesHelpers.getQuestions(peerReviewTemplate) || List();

  const template = ReviewsUtils.getFormTemplateForForm({ review, templateFormType: 'compilation' });
  const questions = ReviewFormTemplatesHelpers.getQuestions(template);

  const mergedQuestions = questions.map(question => {
    const summarizedKey = ReviewFormTemplatesHelpers.getSummarizedQuestionKey(question);
    return question.merge(
      peerReviewQuestions
        .find(question => {
          const key = ReviewFormTemplatesHelpers.getQuestionKey(question);
          return key === summarizedKey;
        })
        ?.delete('key')
        ?.delete('type')
    );
  });

  if (!answers) return null;

  return <ReviewForm questions={mergedQuestions} answers={answers?.toJS()} formData={formData} formSlug={formSlug} />;
};

export default SharePageReviewForm;
